import React from 'react'

const JobNotification = () => {
  return (
    <div className='flex justify-center items-center min-h-[calc(100vh-60px)] sm:min-h-[calc(100vh-70px)]'>
      <p className='text-white text-2xl font-bold'>This Page Come Soon</p>
    </div>
  )
}

export default JobNotification
